import { Component, forwardRef, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { IconComponent } from '../icon/icon.component';
import { NgClass } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-checkbox-input',
  imports: [ReactiveFormsModule, IconComponent, NgClass],
  templateUrl: './checkbox-input.component.html',
  styleUrl: './checkbox-input.component.scss',
  providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CheckboxInputComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => CheckboxInputComponent),
        multi: true
      }
    ],
})
export class CheckboxInputComponent implements ControlValueAccessor, OnInit {

    private translateService = inject(TranslateService);
    @Input() label: string = '';
    @Input() description: string = '';
    @Input() extraClass: string = '';
    @Input() errorMessage: string = '';
    @Input() submitAttempted: boolean = false;
    @Input() formControlName: string = '';
    @Input() filled: boolean = false;
    @Input() size: 'sm' | 'lg' = 'sm';
    /** Hide label / ng-content column (e.g. icon-only checkbox in a table). */
    @Input() labelHidden = false;
    /** Screen reader label when `labelHidden` is true. */
    @Input() ariaLabel = '';

    control!: FormControl;
  
    ngOnInit(): void {
      if (!this.errorMessage) {
        this.errorMessage = this.translateService.instant('GENERAL.invalidValue');
      }
    }
  
    required: boolean = false;
    value: boolean = false;
    isDisabled: boolean = false;
    hasErrors: boolean = false;
  
    onChange: (value: any) => void = () => {};
  
    onTouched: () => void = () => {};
  
    writeValue(value: any): void {
      this.value = value || false;
    }
  
    registerOnChange(fn: any): void {
      this.onChange = fn;
    }
  
    registerOnTouched(fn: any): void {
      this.onTouched = fn;
    }
  
    setDisabledState(isDisabled: boolean): void {
      this.isDisabled = isDisabled;
    }
  
    handleInput(event: Event): void {
      const input = event.target as HTMLInputElement | null;
      if (input) {
        this.value = input.checked;
        this.onChange(input.checked);
      }
    }
  
    validate(control: AbstractControl): ValidationErrors | null {
      this.control = control as FormControl;
      this.required = control.hasValidator(Validators.required);
      return null;
    }

    get isInvalid(): boolean {
      return this.control?.invalid && this.submitAttempted;
    }
}
